import { NodeAxios } from '../api'

import type { IdentitySubjectKind } from '@/modules/campaigns/components/identity-engine/identity-record.util'

export type ActivateHeftSubjectResponse = {
    subjectType: IdentitySubjectKind
    subjectId: string
    heftPath: string
    heftProfile: {
        completeness_score: number
        interview_count: number
        story_count: number
        enrichment_status: string
    }
    activated: boolean
}

export const identityEngineService = {
    async activateHeftSubject(
        subjectType: IdentitySubjectKind,
        subjectId: string,
    ): Promise<ActivateHeftSubjectResponse> {
        const res = await NodeAxios.post(
            `/campaigns/heft/subjects/${subjectType}/${subjectId}/activate`,
        )
        return (res as { data?: ActivateHeftSubjectResponse }).data ?? (res as ActivateHeftSubjectResponse)
    },
}
